module.exports = __webpack_public_path__ + "img/Caldera.00fdad53.jpg";